import { Routing } from "@singularsystems/neo-react";
import SecurityConfigView from "./Views/SecurityConfigView";

const SecurityConfigRoute: Routing.IMenuRoute =
    { name: "Security Config (Dev)", path: '/security/config', component: SecurityConfigView }

export {SecurityConfigRoute}